import _ from 'lodash';

const deepCamelizeKeys = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(deepCamelizeKeys);
  } else if (_.isPlainObject(obj)) {
    return _.mapKeys(_.mapValues(obj, deepCamelizeKeys), (v, k) => _.camelCase(k));
  }
  return obj;
}

export default deepCamelizeKeys;
